import { render, staticRenderFns } from "./headerBgControl.vue?vue&type=template&id=eb8daa30&scoped=true&"
import script from "./headerBgControl.vue?vue&type=script&lang=js&"
export * from "./headerBgControl.vue?vue&type=script&lang=js&"
import style0 from "./headerBgControl.vue?vue&type=style&index=0&id=eb8daa30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8daa30",
  null
  
)

export default component.exports